export var WIDGET_SUPPORT_CHATBOT = 'WIDGET_SUPPORT_CHATBOT';
export var WIDGET_SDK_CHANNEL = 'WIDGET_SDK_CHANNEL';
export var TOOLTIP_CLOSE_TIMEOUT = 48 * 60 * 60 * 1000; // 48h
export var WidgetEvents;
(function (WidgetEvents) {
    WidgetEvents["NEW"] = "new";
    WidgetEvents["LOG_MESSAGE"] = "log_message";
    WidgetEvents["UPDATE_LOAD_PAGE_URL"] = "load_page_url";
    WidgetEvents["UPDATE_DEALER_OFFER_PARAMS"] = "update_dealer_offer_params";
    WidgetEvents["UPDATE_ARTICLE_URI"] = "update_article_uri";
    // add new values in camelCase
    WidgetEvents["UPDATE_ORIG_PARAMS"] = "updateOrigParams";
    WidgetEvents["GET_ORIG_PARAMS_RESPONSE"] = "getOrigParamsResponse";
    WidgetEvents["SET_INITIAL_PARAMS"] = "setInitialParams";
    WidgetEvents["CONTEXT_CHANGE"] = "contextChange";
    WidgetEvents["CALL_SDK_METHOD_REQUEST"] = "callSdkMethodRequest";
    WidgetEvents["CALL_SDK_METHOD_RESPONSE"] = "callSdkMethodResponse";
    WidgetEvents["CALL_INTERNAL_HANDLER_REQUEST"] = "callInternalSdkMethodRequest";
    WidgetEvents["CALL_INTERNAL_HANDLER_RESPONSE"] = "callInternalSdkMethodResponse";
    WidgetEvents["TOGGLE_CHATBOT_VISIBLE"] = "toggleChatbotVisible";
    WidgetEvents["TOGGlE_WIDGET_EXPANDED"] = "toggleWidgetExpanded";
    WidgetEvents["UPDATE_WIDGET_URL"] = "updateWidgetUrl";
})(WidgetEvents || (WidgetEvents = {}));
export var Platform;
(function (Platform) {
    Platform["UNKNOWN"] = "UNKNOWN";
    Platform["DESKTOP"] = "DESKTOP";
    Platform["MOBILE"] = "MOBILE";
    Platform["APP"] = "APP";
})(Platform || (Platform = {}));
export var Editor;
(function (Editor) {
    Editor["UNKNOWN"] = "UNKNOWN";
    Editor["EDITOR_X"] = "EDITOR_X";
    Editor["EDITOR"] = "EDITOR";
    Editor["ADI"] = "ADI";
})(Editor || (Editor = {}));
//# sourceMappingURL=widgetMessaging.js.map